export var MessagingDealer;
(function (MessagingDealer) {
    MessagingDealer["POPBILL"] = "POPBILL";
})(MessagingDealer || (MessagingDealer = {}));
